"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick Howland (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1504))
 * @trackcomponent
 * @lastsynced 2025-03-05T20:51:48.831Z
 */
export const CartItems = createSVGIcon(
  <>
    <path
      d="M20.744 14.7137H7.02974L5.31545 5.28516H22.1463C22.2715 5.28566 22.3951 5.31358 22.5083 5.36696C22.6215 5.42034 22.7217 5.49787 22.8018 5.59411C22.8819 5.69036 22.9399 5.80297 22.9717 5.92403C23.0036 6.0451 23.0086 6.17168 22.9863 6.29487L21.584 14.0092C21.5484 14.2062 21.4448 14.3846 21.2914 14.5133C21.138 14.642 20.9443 14.7129 20.744 14.7137Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.31201 5.28571L4.59201 1.68571C4.55249 1.49211 4.44729 1.3181 4.29422 1.19315C4.14115 1.06819 3.94961 0.99996 3.75201 1H1.0263"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.02609 14.7148L7.74437 18.3148C7.78395 18.5087 7.8894 18.683 8.04283 18.808C8.19625 18.9329 8.3882 19.001 8.58609 19.0006H18.1689"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.1689 22.4294C18.1689 22.6567 18.0786 22.8748 17.9179 23.0355C17.7571 23.1962 17.5391 23.2866 17.3118 23.2866C17.0845 23.2866 16.8665 23.1962 16.7057 23.0355C16.545 22.8748 16.4547 22.6567 16.4547 22.4294C16.4547 22.2021 16.545 21.9841 16.7057 21.8233C16.8665 21.6626 17.0845 21.5723 17.3118 21.5723C17.5391 21.5723 17.7571 21.6626 17.9179 21.8233C18.0786 21.9841 18.1689 22.2021 18.1689 22.4294Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4551 22.4294C10.4551 22.6567 10.3648 22.8748 10.204 23.0355C10.0433 23.1962 9.82526 23.2866 9.59794 23.2866C9.37061 23.2866 9.15259 23.1962 8.99184 23.0355C8.8311 22.8748 8.74079 22.6567 8.74079 22.4294C8.74079 22.2021 8.8311 21.9841 8.99184 21.8233C9.15259 21.6626 9.37061 21.5723 9.59794 21.5723C9.82526 21.5723 10.0433 21.6626 10.204 21.8233C10.3648 21.9841 10.4551 22.2021 10.4551 22.4294Z"
      fill="currentColor"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.8755 8.88281V10.5971"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.3008 8.88281V10.5971"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6001 8.88281V10.5971"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "CartItems",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
